module.exports = "/labor-cost/index-73569a.html";